import React from 'react'
import clsx from 'clsx'
import { useRouter } from 'next/router'

import { historyUtils } from '@wartek-id/toolbox-helper'
import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarTitle,
  HeaderBarRightAction,
} from '@wartek-id/header-bar'
import { Icon } from '@wartek-id/icon-v2'

import { HELPDESK_LINK } from 'app/DocumentCollectionPage/constants'

interface IHeaderProps {
  icon?: string
  title?: string
  showHelpButton?: boolean
  headerLeftOnClick?: () => void
  headerRightOnClick?: () => void
}

const Header: React.FC<IHeaderProps> = ({
  icon = 'arrow_back',
  title,
  showHelpButton = false,
  headerLeftOnClick,
  headerRightOnClick,
}) => {
  const router = useRouter()

  return (
    <>
      <HeaderBar fixed>
        <HeaderBarLeftAction
          icon={<Icon>{icon}</Icon>}
          onClick={() => {
            headerLeftOnClick?.()
            historyUtils.backToApp(() => {
              const isNewActivity = window.history.length <= 2
              if (isNewActivity) router.push('/home')
              else router.back()
            })
          }}
        />
        <HeaderBarTitle className={clsx(!showHelpButton && '!pr-2')}>
          {title}
        </HeaderBarTitle>
        {showHelpButton && (
          <HeaderBarRightAction type="text" className="whitespace-nowrap">
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a
              href={HELPDESK_LINK}
              target="_blank"
              onClick={() => headerRightOnClick?.()}
            >
              Bantuan
            </a>
          </HeaderBarRightAction>
        )}
      </HeaderBar>
    </>
  )
}

export default Header
